import { Lesson } from '../../../../types';

const lesson: Lesson = {
  itemId: '2079355',
  title: 'O que são as Velas (Candlesticks)',
  video: { platform: 'youtube', videoId: 'LJ_7avY_gr0' },
  article: [
    'Nesta aula veremos a leitura de velas e sua importância.',
  ],
};

export default lesson;

